// @ts-nocheck
import React from 'react';
import { authUtils } from '../../utils/auth';
import './Auth.css';

interface LoginPageProps {
  onLoginSuccess: () => void;
  onShowFeatures: () => void;
  importHint: string | null;
}

const highlights = [
  { icon: '📚', title: '智能阅读', desc: 'AI 驱动的论文分析与理解', color: 'purple' },
  { icon: '🎯', title: '空间学习', desc: '无限画布可视化知识网络', color: 'amber' },
  { icon: '💬', title: '深度对话', desc: '苏格拉底式批判性思考引导', color: 'emerald' },
  { icon: '✨', title: '渐进式流程', desc: '四阶段系统化学习方法', color: 'rose' },
];

export default function LoginPage({ onShowFeatures, importHint }: LoginPageProps) {
  return (
    <div className="auth-container">
      <div className="auth-brand">
        <div className="brand-header">
          <div className="brand-logo">
            <div className="brand-logo-icon">📖</div>
            <span className="brand-logo-text">PDF MindMap</span>
          </div>
          <h1 className="brand-welcome">让文档变成可探索的知识空间</h1>
          <p className="brand-subtitle">
            阅读产品介绍无需登录；上传文档、AI 问答与保存进度使用 NGJOO 统一账户。
          </p>
        </div>

        <div className="feature-highlights">
          {highlights.map((item) => (
            <div className="highlight-card" key={item.title}>
              <div className={`highlight-icon ${item.color}`}>{item.icon}</div>
              <div className="highlight-title">{item.title}</div>
              <div className="highlight-desc">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="auth-form-section">
        <div className="auth-box">
          <h1 className="auth-title">开始使用</h1>
          <p className="auth-subtitle">一次登录，即可使用 NGJOO 的所有产品。</p>
          <button type="button" className="auth-submit" onClick={() => authUtils.login()}>
            使用 NGJOO 账户继续
          </button>

          <div className="auth-features">
            <button className="auth-features-link" onClick={onShowFeatures}>
              先查看功能介绍
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {importHint && (
            <div className="auth-import-hint">登录后将自动导入论文：{importHint}</div>
          )}

          <div className="auth-demo-hint">登录由 accounts.ngjoo.com 安全处理</div>
        </div>
      </div>
    </div>
  );
}
